import { withInstall } from '@hd-front-end/utils'
import Autocomplete from './src/autocomplete.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElAutocomplete: SFCWithInstall<typeof Autocomplete> =
  withInstall(Autocomplete)

export default ElAutocomplete

export * from './src/autocomplete'
